import { render, staticRenderFns } from "./ResultJ.vue?vue&type=template&id=b48e9a28&"
import script from "./ResultJ.vue?vue&type=script&lang=js&"
export * from "./ResultJ.vue?vue&type=script&lang=js&"
import style0 from "./ResultJ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports